import React, { useCallback, useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import "./ModalResearch.styles.scss";
import { InlineIcon } from "@iconify/react";
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Grow,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  styled,
  TextField,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Switch,
  Slider, // <-- NOUVEAU
} from "@mui/material";

import { apiGetSearchEthniesAndOrigins } from "@/features/profile/api/search.api";
import { TFilteredQuery } from "@/features/profile/types";
import { store } from "@/store";
import {
  updateFormQuery,
  updateSearchQuery,
} from "@/store/reducers/general_param/general_param.actions";
import { selectFormQuery } from "@/store/reducers/general_param/general_param.selector";
import { updateLocation } from "@/store/reducers/member/member.actions";
import { Toastify } from "@/utils/toast";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import { MultipleSelectChip } from "../MultipleSelectChip/MultipleSelectChip";
import { TMemberProfile } from "@/features/auth/types";
import { selectMemberProfile } from "@/store/reducers/member/member.selector";
import useUserRestrictions from "@/hooks/useUserRestriction";
import CModalInviteCorrectAdress from "../Modal-invite-correct-adress/ModalInviteCorrectAdress";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

interface ModalResearchProps {
  open: boolean;
  loadingFromHome: boolean;
  onClose:
    | ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void)
    | undefined;
  closeClick: () => void;
  applyFilter: (query: string) => void;
}

type TCheckBoxList = Array<{ name: string; checked: boolean }>;

/**
 * Marques du Slider : 4 positions fixes : 50 km, 100 km, 200 km, 500 km
 */
const distanceMarks = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 200, label: "200" },
  { value: 300, label: "300" },
  { value: 400, label: "400" },
  { value: 500, label: "500" },
];

// Tenues vestimentaires
const tenues_vestimentaires_femmes_list = [
  "Ne porte pas encore le voile",
  "Porte le turban",
  "Porte le Hijab",
  "Porte le Jilbab",
  "Porte le Niqab",
  "L'Abaya",
];

// Situations matrimoniales
const situation_matrimoniale_femme_list = [
  "Jamais Mariée",
  "Divorcée",
  "Veuve",
];
const situation_matrimoniale_homme_list = [
  "Jamais Marié",
  "Divorcé",
  "Veuf",
  "Marié",
];

const ModalResearch = ({
  open,
  loadingFromHome,
  onClose,
  closeClick,
  applyFilter,
}: ModalResearchProps) => {
  const memberProfileFromStore = useSelector(
    selectMemberProfile
  ) as TMemberProfile;
  const form_query = useSelector(selectFormQuery);

  const [loadingList, setLoadingList] = useState(false);
  const navigate = useNavigate();

  // Listes de cases à cocher
  const [originList, setOriginList] = React.useState<TCheckBoxList>([]);
  const [ethniesList, setEthiesList] = React.useState<TCheckBoxList>([]);
  const [countriesResidenceList, setCountriesResidenceList] =
    React.useState<TCheckBoxList>([]);
  const [cityResidenceList, setCityResidenceList] =
    React.useState<TCheckBoxList>([]);

  /** Handlers pour cocher/décocher Origines, Ethnies, Pays, Villes. */
  const handleOriginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tempList = originList.slice();
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const exist = tempList.findIndex((elt) => elt.name === event.target.name);
      if (exist !== -1) {
        tempList[exist].checked = event.target.checked;
      }
      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setOriginList(tempList);
  };

  const handleEthniesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tempList = ethniesList.slice();
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const exist = tempList.findIndex((elt) => elt.name === event.target.name);
      if (exist !== -1) {
        tempList[exist].checked = event.target.checked;
      }
      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setEthiesList(tempList);
  };

  const handleCountriesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const tempList = countriesResidenceList.slice();
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const exist = tempList.findIndex((elt) => elt.name === event.target.name);
      if (exist !== -1) {
        tempList[exist].checked = event.target.checked;
      }
      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setCountriesResidenceList(tempList);
  };

  const handleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tempList = cityResidenceList.slice();
    if (event.target.name === "Peu importe") {
      tempList.forEach((et) => (et.checked = event.target.checked));
    } else {
      const exist = tempList.findIndex((elt) => elt.name === event.target.name);
      if (exist !== -1) {
        tempList[exist].checked = event.target.checked;
      }
      const idxAny = tempList.findIndex((elt) => elt.name === "Peu importe");
      if (idxAny !== -1) tempList[idxAny].checked = false;
    }
    setCityResidenceList(tempList);
  };

  /**
   * Schéma de validation YUP
   */
  const validationSchema = yup.object({
    age_minimum: yup
      .number()
      .min(18, "l'âge minimum est de 18 ans")
      .max(70, "l'âge maximum est de 70 ans")
      .test({
        name: "min_over_max",
        message: "l'âge minimum doit être inférieure à l'âge maximum",
        test: function (value, ctx) {
          if (!value) return true; // pas de saisie => pas d’erreur
          if (ctx.parent.age_maximum) {
            return value < ctx.parent.age_maximum;
          }
          return value < 70;
        },
      }),
    age_maximum: yup
      .number()
      .min(18, "l'âge minimum est de 18 ans")
      .max(70, "l'âge maximum est de 70 ans")
      .test({
        name: "max_over_min",
        message: "l'âge maximum doit être supérieure à l'âge minimum",
        test: function (value, ctx) {
          if (!value) return true; // pas de saisie => pas d’erreur
          if (ctx.parent.age_minimum) {
            return value > ctx.parent.age_minimum;
          }
          return true;
        },
      }),
    // howFarFromMe : l’utilisateur choisit seulement parmi 50,100,200,500 => pas forcément besoin de le valider
  });

  /**
   * Formik
   *
   * On y ajoute les champs :
   *   - enableAroundMe (bool)
   *   - howFarFromMe (nombre)
   *   - myLocation : { lat, lng }
   */
  const formik = useFormik({
    initialValues: {
      age_minimum: form_query.age_minimum,
      age_maximum: form_query.age_maximum,
      tenue_vestimentaire_femme: form_query.tenue_vestimentaire_femme,
      fast_filter: form_query.fast_filter,
      without_account: form_query.without_account,
      situation_matrimoniale: form_query.situation_matrimoniale,
      situation_parentale: form_query.situation_parentale,
      accepte_enfants: form_query.accepte_enfants,
      accepte_married_man: form_query.accepte_married_man,
      profils_salafi: form_query.profils_salafi,
      accepte_demenager: form_query.accepte_demenager,
      etant_hijra: form_query.etant_hijra,
      souhait_hijra: form_query.souhait_hijra,
      recherche_mon_ethnie: form_query.recherche_mon_ethnie,

      // NOUVEAUX CHAMPS :
      enableAroundMe: form_query.enableAroundMe || false,
      howFarFromMe: form_query.howFarFromMe || 50, // par défaut 50km
      myLocation: form_query.myLocation || { lat: "", lng: "" },
    },
    validationSchema,
    onSubmit: (values) => {
      // On prépare la data
      const dataToSend = {
        ...values,
        tenue_vestimentaire_femme: setArrayToGoodValue(
          values.tenue_vestimentaire_femme
        ),
        situation_matrimoniale: setArrayToGoodValue(
          values.situation_matrimoniale
        ),
        originList: cleanList(originList),
        ethniesList: cleanList(ethniesList),
        countriesResidence: cleanList(countriesResidenceList),
        // cityResidence: cleanList(cityResidenceList),
      };

      // Màj du store (pour mémoriser ce que l’utilisateur a choisi)
      store.dispatch(
        updateFormQuery({
          ...values,
          originList: dataToSend.originList,
          ethniesList: dataToSend.ethniesList,
          countriesResidence: dataToSend.countriesResidence,
          // cityResidence: dataToSend.cityResidence,
        } as TFilteredQuery)
      );

      // Construction de la query
      const queryToSend = buildQueryString(dataToSend);
      store.dispatch(updateSearchQuery(queryToSend));

      // Lancement de l’action
      applyFilter(queryToSend);
    },
    onReset: (values) => {
      // quand on clique sur Réinitialiser
      if (!loadingFromHome) {
        resetFilter();
        applyFilter("");
      }
    },
  });

  /**
   * resetFilter : réinitialise tous les champs
   */
  const resetFilter = useCallback(() => {
    const initValues = {
      age_minimum: "",
      age_maximum: "",
      tenue_vestimentaire_femme: [],
      fast_filter: "",
      without_account: "",
      situation_matrimoniale: [],
      situation_parentale: "",
      accepte_enfants: "",
      accepte_married_man: "",
      profils_salafi: "",
      accepte_demenager: "",
      etant_hijra: "",
      souhait_hijra: "",
      recherche_mon_ethnie: "",
      originList: [],
      ethniesList: [],
      countriesResidence: [],
      cityResidence: [],
      howFarFromMe: 50,
      myLocation: { lat: "", lng: "" },
      enableAroundMe: false,
    };
    // On force Formik à prendre les nouvelles valeurs
    formik.setFieldValue("enableAroundMe", false);
    formik.setFieldValue("howFarFromMe", 50);

    // on réinitialise toutes les checkbox en local
    setOriginList(originList.map((et) => ({ ...et, checked: false })));
    setEthiesList(ethniesList.map((et) => ({ ...et, checked: false })));
    setCountriesResidenceList(
      countriesResidenceList.map((et) => ({ ...et, checked: false }))
    );
    setCityResidenceList(
      cityResidenceList.map((et) => ({ ...et, checked: false }))
    );

    // on informe le store qu’on a tout “vidé”
    store.dispatch(updateFormQuery({ ...initValues } as TFilteredQuery));
    store.dispatch(updateSearchQuery(""));

    Toastify(`Le filtre de recherche a bien été réinitialisé`, "success", 5000);
  }, [countriesResidenceList, ethniesList, originList, cityResidenceList]);

  /**
   * buildQueryString : construit la query à partir de la data
   * S’il y a enableAroundMe => on envoie lat/lng + distance
   * Sinon => on utilise la logique normale (pays, etc).
   */
  const buildQueryString = (values: any): string => {
    let result = "";

    // Filtre rapide
    if (values.fast_filter === "consulted") {
      result += "&isVisited=true";
    } else if (values.fast_filter === "not_consulted") {
      result += "&isVisited=false";
    } else if (values.fast_filter === "my_spectators") {
      result += "&hasVisited=true";
    }

    // Profils sans abonnement
    if (values.without_account !== "") {
      // “true” => afficher SANS abonnements => &onlyWithSubscription=false
      // “false” => afficher AVEC abonnements => &onlyWithSubscription=true
      const onlyWithSub = values.without_account === "true" ? "false" : "true";
      result += `&onlyWithSubscription=${onlyWithSub}`;
    }

    // Age
    if (values.age_minimum !== "") result += `&minAge=${values.age_minimum}`;
    if (values.age_maximum !== "") result += `&maxAge=${values.age_maximum}`;

    // Tenue vestimentaire
    if (values.tenue_vestimentaire_femme.length > 0) {
      result +=
        "&femaleDressCode[]=" +
        values.tenue_vestimentaire_femme.join("&femaleDressCode[]=");
    }

    // Situation matrimoniale
    if (values.situation_matrimoniale.length > 0) {
      result +=
        "&maritalStatus[]=" +
        values.situation_matrimoniale.join("&maritalStatus[]=");
    }

    // Situation parentale
    if (values.situation_parentale !== "") {
      result += `&haveChildren=${values.situation_parentale}`;
    }

    // Qui accepte enfants ?
    if (values.accepte_enfants !== "") {
      result += `&acceptChildren=${values.accepte_enfants}`;
    }

    // Qui accepte hommes mariés ?
    if (values.accepte_married_man !== "") {
      result += `&acceptMarriedMan=${values.accepte_married_man}`;
    }

    // Profils salafis ?
    if (values.profils_salafi !== "") {
      result += `&isSalafi=${values.profils_salafi}`;
    }

    // Qui accepte déménager ?
    if (values.accepte_demenager !== "") {
      result += `&agreeToMove=${values.accepte_demenager}`;
    }

    // Hijra
    if (values.etant_hijra !== "") {
      result += `&isInHijra=${values.etant_hijra}`;
    }
    if (values.souhait_hijra !== "") {
      result += `&likeToMakeHijra=${values.souhait_hijra}`;
    }

    // Profil qui recherche mon ethnie
    if (values.recherche_mon_ethnie !== "") {
      result += `&wantMyEthnicity=${values.recherche_mon_ethnie}`;
    }

    // Ethnies recherchées
    if (values.ethniesList.length > 0) {
      result +=
        "&wantedEthnicities[]=" +
        customArrayToString(values.ethniesList, true, "&wantedEthnicities[]=");
    }

    // Origines recherchées
    if (values.originList.length > 0) {
      result +=
        "&wantedCountries[]=" +
        customArrayToString(values.originList, false, "&wantedCountries[]=");
    }

    // Pays de résidence recherchés
    // => UNIQUEMENT si on n’est PAS en mode “autour de ma ville”
    if (!values.enableAroundMe && values.countriesResidence.length > 0) {
      result +=
        "&wantedCountriesResidence[]=" +
        customArrayToString(
          values.countriesResidence,
          false,
          "&wantedCountriesResidence[]="
        );
    }

    // City ...
    // if (!values.enableAroundMe && values.cityResidence.length > 0) {
    //   result +=
    //     "&wantedCityResidence[]=" +
    //     customArrayToString(
    //       values.cityResidence,
    //       false,
    //       "&wantedCityResidence[]="
    //     );
    // }

    // SI enableAroundMe => on envoie lat, lng et distance
    if (values.enableAroundMe) {
      // result += `&latitude=${values.myLocation.lat}`;
      // result += `&longitude=${values.myLocation.lng}`;
      result += `&distance=${values.howFarFromMe}`;
    }

    return result;
  };

  /**
   * Supprime les items “Peu importe” cochés + ne garde que ceux qui ont “checked=true”.
   */
  const cleanList = (data: TCheckBoxList): TCheckBoxList => {
    return data.filter((item) => item.checked && item.name !== "Peu importe");
  };

  /**
   * Convertit vos libellés en code pour la requête (voile => wearHijab, etc.)
   */
  const setArrayToGoodValue = (arr: string[]): string[] => {
    const result: string[] = [];
    arr.forEach((elt) => {
      // Tenue vestimentaire
      if (elt === "Ne porte pas encore le voile")
        result.push("notWearHeadscarf");
      if (elt === "Porte le turban") result.push("wearTurban");
      if (elt === "Porte le Hijab") result.push("wearHijab");
      if (elt === "Porte le Jilbab") result.push("wearJilbab");
      if (elt === "Porte le Niqab") result.push("wearNiqab");
      if (elt === "L'Abaya") result.push("wearAbaya");

      // Situation maritale
      if (elt === "Jamais Mariée" || elt === "Jamais Marié")
        result.push("NEVER_MARRIED");
      if (elt === "Divorcée" || elt === "Divorcé") result.push("DIVORCED");
      if (elt === "Veuve" || elt === "Veuf") result.push("WIDOW");
      if (elt === "Marié") result.push("MARRIED");
    });
    return result;
  };

  /**
   * Construit la chaîne en joignant soit l’id, soit le name,
   * selon le 2e param `isId`.
   */
  const customArrayToString = (
    arr: any[],
    isId: boolean = false,
    joinString: string = ","
  ): string => {
    let result: string[] = [];
    if (isId) {
      arr.forEach((elt) => result.push(elt.id));
    } else {
      arr.forEach((elt) => result.push(elt.name));
    }
    return result.join(joinString);
  };

  /**
   * Au montage du composant, si `open` alors on charge la liste (origines, ethnies, pays...).
   * (Vous aviez déjà un geolocation.getCurrentPosition, on le laisse si besoin.)
   */
  useEffect(() => {
    if (open) {
      setLoadingList(true);
      apiGetSearchEthniesAndOrigins()
        .then((response: any) => {
          setLoadingList(false);
          const { origins, ethnicities, countriesOfResidence } = response.data;

          // Origines
          const tempOriginList = origins.map((data: any) => ({
            name: data,
            checked:
              form_query.originList.find((x) => x.name === data) !== undefined,
          }));
          setOriginList([
            { name: "Peu importe", checked: false },
            ...tempOriginList,
          ]);

          // Ethnies
          const tempEthniesList = ethnicities.map((data: any) => ({
            id: data._id,
            name: data.name,
            checked:
              form_query.ethniesList.find((x) => x.name === data.name) !==
              undefined,
          }));
          setEthiesList([
            { name: "Peu importe", checked: false },
            ...tempEthniesList,
          ]);

          // Pays
          if (!form_query.countriesResidence) {
            store.dispatch(
              updateFormQuery({ ...form_query, countriesResidence: [] })
            );
          }
          const tempCountries = countriesOfResidence.map((data: any) => ({
            name: data,
            checked:
              form_query?.countriesResidence?.find(
                (x: any) => x.name === data
              ) !== undefined,
          }));
          setCountriesResidenceList([
            { name: "Peu importe", checked: false },
            ...tempCountries,
          ]);

          // Villes
          // (Désactivé dans le code, mais même principe si needed)
          // if (!form_query.cityResidence) {
          //   store.dispatch(
          //     updateFormQuery({ ...form_query, cityResidence: [] })
          //   );
          // }
          // ...
        })
        .catch((error) => {
          setLoadingList(false);
          // Gérer le cas d’erreur
          console.log(error);
          Toastify(
            "Impossible de charger la liste d’origines/ethnies",
            "error",
            3000
          );
        });
    }
  }, [open]);

  // Gestion des champs de recherche textuelle (origines, etc.)
  const [searchedOriginText, setSearchedOriginText] = useState("");
  const handleSearchOriginTextChange = useCallback((e: any) => {
    setSearchedOriginText(e.target.value);
  }, []);
  const clearOriginTextSearch = useCallback(() => {
    setSearchedOriginText("");
  }, []);

  const [searchedEthnieText, setSearchedEthnieText] = useState("");
  const handleSearchEthnieTextChange = useCallback((e: any) => {
    setSearchedEthnieText(e.target.value);
  }, []);
  const clearEthnieTextSearch = useCallback(() => {
    setSearchedEthnieText("");
  }, []);

  const [searchedCountryText, setSearchedCountryText] = useState("");
  const handleSearchCountryTextChange = useCallback((e: any) => {
    setSearchedCountryText(e.target.value);
  }, []);
  const clearCountryTextSearch = useCallback(() => {
    setSearchedCountryText("");
  }, []);

  const [searchedCityText, setSearchedCityText] = useState("");
  const handleSearchCityTextChange = useCallback((e: any) => {
    setSearchedCityText(e.target.value);
  }, []);
  const clearCityTextSearch = useCallback(() => {
    setSearchedCityText("");
  }, []);

  const { hasUserUnproperedCityCountryMatch } = useUserRestrictions();

  // ------------------------------------------------------------------------
  // Rendu
  // ------------------------------------------------------------------------
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={onClose}
        closeAfterTransition
      >
        <Slide direction="left" in={open} mountOnEnter unmountOnExit>
          <div className="c-modal-research">
            {/* Header */}
            <div className="c-modal-research__title-part">
              <IconButton
                className="back-icon"
                size="medium"
                color="secondary"
                onClick={closeClick}
              >
                <InlineIcon icon="tabler:chevron-left" />
              </IconButton>
              <span className="title">Critères de recherches</span>
              <IconButton
                className="close-icon"
                size="medium"
                color="secondary"
                onClick={closeClick}
              >
                <InlineIcon icon="iconamoon:close-bold" />
              </IconButton>
            </div>

            {/* Boutons d’action */}
            <div className="c-modal-research__actions-part">
              <Chip
                className="action-chip erase"
                color="primary"
                variant="outlined"
                size="medium"
                label="Réinitialiser"
                disabled={loadingFromHome}
                icon={<InlineIcon icon={"carbon:reset"} />}
                onClick={(e) => {
                  if (!loadingFromHome) formik.handleReset(e);
                }}
              />

              <Chip
                className="action-chip"
                color="primary"
                variant="filled"
                size="medium"
                label="Effectuer le filtre"
                disabled={loadingFromHome}
                icon={
                  <InlineIcon
                    icon={
                      loadingFromHome
                        ? "eos-icons:three-dots-loading"
                        : "mingcute:check-fill"
                    }
                  />
                }
                onClick={() => {
                  if (!loadingFromHome) formik.handleSubmit();
                }}
              />
            </div>

            {/* Corps du Modal */}
            {loadingFromHome ? (
              <img
                src={require("@/assets/images/gif/loadmore.gif")}
                height="70"
                width="70"
                className="load-more"
                alt="load-more"
              />
            ) : (
              <form
                className="c-modal-research__body-part"
                onSubmit={formik.handleSubmit}
                onReset={formik.handleReset}
              >
                <Box>
                  <Grid container rowSpacing={3} columnSpacing={2}>
                    {/* Switch - Chercher autour de ma ville ? */}
                    <Grid item xs={12}>
                      <FormControlLabel
                        className="ctrl-label"
                        label="Chercher les profils autour de ma ville ?"
                        control={
                          <Switch
                            checked={formik.values.enableAroundMe}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "enableAroundMe",
                                e.target.checked
                              );
                              // s’il vient d’activer le switch => on tente de récupérer la géoloc
                              // if (e.target.checked) {
                              //   navigator.geolocation.getCurrentPosition(
                              //     (pos) => {
                              //       const lat = pos.coords.latitude.toString();
                              //       const lng = pos.coords.longitude.toString();
                              //       formik.setFieldValue("myLocation", {
                              //         lat,
                              //         lng,
                              //       });
                              //       // On peut en plus stocker en global si voulu :
                              //       store.dispatch(
                              //         updateLocation({
                              //           latitude: lat,
                              //           longitude: lng,
                              //         })
                              //       );
                              //     },
                              //     (err) => {
                              //       console.log(err);
                              //      false && Toastify(
                              //         `Impossible de récupérer votre position GPS`,
                              //         "error",
                              //         5000
                              //       );
                              //       // On désactive le switch s’il y a un refus
                              //       formik.setFieldValue(
                              //         "enableAroundMe",
                              //         false
                              //       );
                              //     }
                              //   );
                              // } else {
                              //   // S’il désactive : on vide la location
                              //   formik.setFieldValue("myLocation", {
                              //     lat: "",
                              //     lng: "",
                              //   });
                              // }
                            }}
                          />
                        }
                      />
                    </Grid>

                    {/* Si enableAroundMe = true, on affiche le Slider */}
                    {formik.values.enableAroundMe && (
                      <Grid item xs={12}>
                        <p className="label">Rayon de recherche (Km)</p>
                        <Slider
                          value={formik.values.howFarFromMe}
                          step={null}
                          marks={distanceMarks}
                          min={50}
                          max={500}
                          onChange={(event, newValue) => {
                            // newValue sera l’une des 4 valeurs du marks
                            formik.setFieldValue("howFarFromMe", newValue);
                          }}
                          // Visuellement, on rend le slider plus “serré”
                          sx={{ maxWidth: "90%", marginX: "auto" }}
                        />
                      </Grid>
                    )}

                    {/* Filtre rapide */}
                    <Grid item xs={12} sm={12} lg={12}>
                      <p className="label">Filtre rapide</p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="fast_filter"
                          value={formik.values.fast_filter}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="consulted"
                            control={<Radio />}
                            label="Profils consultés"
                          />
                          <FormControlLabel
                            value="not_consulted"
                            control={<Radio />}
                            label="Profils non consultés"
                          />
                          <FormControlLabel
                            value="my_spectators"
                            control={<Radio />}
                            label="Mes spectateurs"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Sans abonnement */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">
                        Afficher les profils sans abonnements ?
                      </p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="without_account"
                          value={formik.values.without_account}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Oui"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Non"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Age min / max */}
                    <Grid item xs={12} sm={12} lg={12}>
                      <p className="label">Âge minimum (18)</p>
                      <TextField
                        variant="outlined"
                        name="age_minimum"
                        onChange={formik.handleChange}
                        value={formik.values.age_minimum}
                        error={
                          formik.touched.age_minimum &&
                          Boolean(formik.errors.age_minimum)
                        }
                        helperText={
                          formik.touched.age_minimum &&
                          formik.errors.age_minimum
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <span className="suffix">ans</span>
                            </InputAdornment>
                          ),
                        }}
                        type="number"
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} lg={12}>
                      <p className="label">Âge maximum (70)</p>
                      <TextField
                        variant="outlined"
                        name="age_maximum"
                        onChange={formik.handleChange}
                        value={formik.values.age_maximum}
                        error={
                          formik.touched.age_maximum &&
                          Boolean(formik.errors.age_maximum)
                        }
                        helperText={
                          formik.touched.age_maximum &&
                          formik.errors.age_maximum
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <span className="suffix">ans</span>
                            </InputAdornment>
                          ),
                        }}
                        type="number"
                      />
                    </Grid>

                    {/* Tenue vestimentaire (si user = MALE => on choisit la tenue recherchée) */}
                    {memberProfileFromStore?.infos?.identity?.gender ===
                      "MALE" && (
                      <Grid item xs={12} sm={12} lg={12}>
                        <p className="label">Tenue vestimentaire</p>
                        <MultipleSelectChip
                          name="tenue_vestimentaire_femme"
                          selectOptions={tenues_vestimentaires_femmes_list}
                          value={formik.values.tenue_vestimentaire_femme}
                          onChange={formik.handleChange}
                          labelId="id-select-tenue-femme"
                          label=""
                        />
                      </Grid>
                    )}

                    {/* Situation matrimoniale */}
                    <Grid item xs={12} sm={12} lg={12}>
                      {memberProfileFromStore?.infos?.identity?.gender ===
                        "FEMALE" && (
                        <>
                          <p className="label">Situation matrimoniale</p>
                          <MultipleSelectChip
                            name="situation_matrimoniale"
                            selectOptions={situation_matrimoniale_homme_list}
                            value={formik.values.situation_matrimoniale}
                            onChange={formik.handleChange}
                            labelId="id-situation_matrimoniale"
                            label=""
                          />
                        </>
                      )}
                      {memberProfileFromStore?.infos?.identity?.gender ===
                        "MALE" && (
                        <>
                          <p className="label">Situation matrimoniale</p>
                          <MultipleSelectChip
                            name="situation_matrimoniale"
                            selectOptions={situation_matrimoniale_femme_list}
                            value={formik.values.situation_matrimoniale}
                            onChange={formik.handleChange}
                            labelId="id-situation_matrimoniale"
                            label=""
                          />
                        </>
                      )}
                    </Grid>

                    {/* Situation parentale */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">Situation parentale</p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="situation_parentale"
                          value={formik.values.situation_parentale}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Avec enfants"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Sans enfants"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Qui accepte les hommes mariés ? (que si user = MALE) */}
                    {memberProfileFromStore?.infos?.identity?.gender ===
                      "MALE" && (
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <p className="label">Qui accepte les hommes mariés ?</p>
                        <FormControl
                          fullWidth
                          color="primary"
                          className="input-radio"
                        >
                          <RadioGroup
                            row
                            name="accepte_married_man"
                            value={formik.values.accepte_married_man}
                            onChange={formik.handleChange}
                          >
                            <FormControlLabel
                              value="true"
                              control={<Radio />}
                              label="Oui"
                            />
                            <FormControlLabel
                              value="false"
                              control={<Radio />}
                              label="Non"
                            />
                            <FormControlLabel
                              value=""
                              control={<Radio />}
                              label="Peu importe"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    )}

                    {/* Qui accepte les enfants ? */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">Qui accepte les enfants ?</p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="accepte_enfants"
                          value={formik.values.accepte_enfants}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Oui"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Non"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Profils salafi ? */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">
                        N'afficher que les profils salafis ?
                      </p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="profils_salafi"
                          value={formik.values.profils_salafi}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Oui"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Non"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Accepte de déménager ? */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">Qui accepte de déménager ?</p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="accepte_demenager"
                          value={formik.values.accepte_demenager}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Oui"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Non"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Hijra ? */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">Étant en hijra ?</p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="etant_hijra"
                          value={formik.values.etant_hijra}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Oui"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Non"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Souhaitant faire la hijra ? */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">Souhaitant faire la hijra ?</p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="souhait_hijra"
                          value={formik.values.souhait_hijra}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Oui"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Non"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Recherche mon ethnie ? */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <p className="label">
                        Afficher les profils qui recherchent mon ethnie
                      </p>
                      <FormControl
                        fullWidth
                        color="primary"
                        className="input-radio"
                      >
                        <RadioGroup
                          row
                          name="recherche_mon_ethnie"
                          value={formik.values.recherche_mon_ethnie}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Oui"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Non"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="Peu importe"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Origines */}
                    <Grid item xs={12} sm={12} lg={12}>
                      <p className="label">Origines</p>
                      <FormControl className="yel-checkbox-list">
                        <TextField
                          placeholder="Recherche ..."
                          variant="outlined"
                          className="searchInput"
                          type="text"
                          value={searchedOriginText}
                          onChange={handleSearchOriginTextChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Grow in={searchedOriginText === ""}>
                                  <div>
                                    <InlineIcon icon="bi:search" />
                                  </div>
                                </Grow>
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <Grow in={searchedOriginText !== ""}>
                                  <div>
                                    <IconButton
                                      className="sm-btn"
                                      size="medium"
                                      onClick={clearOriginTextSearch}
                                    >
                                      <InlineIcon
                                        icon="mdi:erase"
                                        color="var(--ui-medium)"
                                      />
                                    </IconButton>
                                  </div>
                                </Grow>
                              </InputAdornment>
                            ),
                          }}
                        />

                        <FormGroup className="yel-checkbox-option-container">
                          {loadingList ? (
                            <img
                              src={require("@/assets/images/gif/loadmore.gif")}
                              height="70"
                              width="70"
                              alt="load-more"
                            />
                          ) : (
                            originList
                              .filter((elt) =>
                                elt.name
                                  .toLowerCase()
                                  .normalize("NFD")
                                  .replace(/[\u0300-\u036f]/g, "")
                                  .includes(
                                    searchedOriginText
                                      .toLowerCase()
                                      .normalize("NFD")
                                      .replace(/[\u0300-\u036f]/g, "")
                                  )
                              )
                              .map((origin, index) => (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      color="primary"
                                      checked={origin.checked}
                                      onChange={handleOriginChange}
                                      name={origin.name}
                                    />
                                  }
                                  label={origin.name}
                                />
                              ))
                          )}
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    {/* Ethnies */}
                    <Grid item xs={12} sm={12} lg={12}>
                      <p className="label">Ethnies</p>
                      <FormControl className="yel-checkbox-list">
                        <TextField
                          placeholder="Recherche ..."
                          variant="outlined"
                          className="searchInput"
                          type="text"
                          value={searchedEthnieText}
                          onChange={handleSearchEthnieTextChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Grow in={searchedEthnieText === ""}>
                                  <div>
                                    <InlineIcon icon="bi:search" />
                                  </div>
                                </Grow>
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <Grow in={searchedEthnieText !== ""}>
                                  <div>
                                    <IconButton
                                      className="sm-btn"
                                      size="medium"
                                      onClick={clearEthnieTextSearch}
                                    >
                                      <InlineIcon
                                        icon="mdi:erase"
                                        color="var(--ui-medium)"
                                      />
                                    </IconButton>
                                  </div>
                                </Grow>
                              </InputAdornment>
                            ),
                          }}
                        />

                        <FormGroup className="yel-checkbox-option-container">
                          {loadingList ? (
                            <img
                              src={require("@/assets/images/gif/loadmore.gif")}
                              height="70"
                              width="70"
                              alt="load-more"
                            />
                          ) : (
                            ethniesList
                              .filter((elt) =>
                                elt.name
                                  .toLowerCase()
                                  .normalize("NFD")
                                  .replace(/[\u0300-\u036f]/g, "")
                                  .includes(
                                    searchedEthnieText
                                      .toLowerCase()
                                      .normalize("NFD")
                                      .replace(/[\u0300-\u036f]/g, "")
                                  )
                              )
                              .map((ethny, index) => (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      color="primary"
                                      checked={ethny.checked}
                                      onChange={handleEthniesChange}
                                      name={ethny.name}
                                    />
                                  }
                                  label={ethny.name}
                                />
                              ))
                          )}
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    {/* Pays de résidence */}
                    <Grid item xs={12} sm={12} lg={12}>
                      <p className="label">Pays de résidence</p>
                      <FormControl className="yel-checkbox-list">
                        {formik.values.enableAroundMe && (
                          <p
                            style={{
                              color: "var(--ui-error)",
                              fontStyle: "italic",
                              marginBottom: "10px",
                            }}
                          >
                            Impossible de filtrer par pays lorsque la recherche
                            “autour de ma ville” est activée.
                          </p>
                        )}

                        <TextField
                          placeholder="Recherche ..."
                          variant="outlined"
                          className="searchInput"
                          disabled={formik.values.enableAroundMe}
                          type="text"
                          value={searchedCountryText}
                          onChange={handleSearchCountryTextChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Grow in={searchedCountryText === ""}>
                                  <div>
                                    <InlineIcon icon="bi:search" />
                                  </div>
                                </Grow>
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <Grow in={searchedCountryText !== ""}>
                                  <div>
                                    <IconButton
                                      className="sm-btn"
                                      size="medium"
                                      onClick={clearCountryTextSearch}
                                    >
                                      <InlineIcon
                                        icon="mdi:erase"
                                        color="var(--ui-medium)"
                                      />
                                    </IconButton>
                                  </div>
                                </Grow>
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* On désactive TOUTES les cases si enableAroundMe = true */}
                        <FormGroup className="yel-checkbox-option-container">
                          {loadingList ? (
                            <img
                              src={require("@/assets/images/gif/loadmore.gif")}
                              height="70"
                              width="70"
                              alt="load-more"
                            />
                          ) : (
                            countriesResidenceList
                              .filter((elt) =>
                                elt.name
                                  .toLowerCase()
                                  .normalize("NFD")
                                  .replace(/[\u0300-\u036f]/g, "")
                                  .includes(
                                    searchedCountryText
                                      .toLowerCase()
                                      .normalize("NFD")
                                      .replace(/[\u0300-\u036f]/g, "")
                                  )
                              )
                              .map((country, index) => (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      color="primary"
                                      checked={country.checked}
                                      onChange={handleCountriesChange}
                                      name={country.name}
                                      disabled={formik.values.enableAroundMe}
                                    />
                                  }
                                  label={country.name}
                                />
                              ))
                          )}
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    {/* Villes de résidence (désactivé dans votre code, mais même principe) */}
                    {false && (
                      <Grid item xs={12} sm={12} lg={12}>
                        <p className="label">Ville de résidence</p>
                        <FormControl className="yel-checkbox-list">
                          <TextField
                            placeholder="Recherche ..."
                            variant="outlined"
                            className="searchInput"
                            type="text"
                            value={searchedCityText}
                            onChange={handleSearchCityTextChange}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Grow in={searchedCityText === ""}>
                                    <div>
                                      <InlineIcon icon="bi:search" />
                                    </div>
                                  </Grow>
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Grow in={searchedCityText !== ""}>
                                    <div>
                                      <IconButton
                                        className="sm-btn"
                                        size="medium"
                                        onClick={clearCityTextSearch}
                                      >
                                        <InlineIcon
                                          icon="mdi:erase"
                                          color="var(--ui-medium)"
                                        />
                                      </IconButton>
                                    </div>
                                  </Grow>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <FormGroup className="yel-checkbox-option-container">
                            {loadingList ? (
                              <img
                                src={require("@/assets/images/gif/loadmore.gif")}
                                height="70"
                                width="70"
                                alt="load-more"
                              />
                            ) : (
                              cityResidenceList
                                .filter((elt) =>
                                  elt.name
                                    .toLowerCase()
                                    .normalize("NFD")
                                    .replace(/[\u0300-\u036f]/g, "")
                                    .includes(
                                      searchedCityText
                                        .toLowerCase()
                                        .normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")
                                    )
                                )
                                .map((city, index) => (
                                  <FormControlLabel
                                    key={index}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={city.checked}
                                        onChange={handleCityChange}
                                        name={city.name}
                                        disabled={formik.values.enableAroundMe}
                                      />
                                    }
                                    label={city.name}
                                  />
                                ))
                            )}
                          </FormGroup>
                        </FormControl>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </form>
            )}
          </div>
        </Slide>
      </Modal>
      {/* <CModalInviteCorrectAdress open={hasUserUnproperedCityCountryMatch} /> */}
    </>
  );
};

export default ModalResearch;
